import { NextResponse } from "next/server"
import { z } from "zod"
import { getSession } from "@/services/auth-service"
import { getProductReviewPermission } from "@/services/product-review-service"

const NO_CACHE_HEADERS = {
  "Cache-Control": "no-store",
} as const

const productParamsSchema = z.object({
  id: z
    .string()
    .regex(/^[1-9]\d*$/, "Product id must be a positive integer.")
    .transform((value) => Number(value)),
})

const toPermissionFetchFailedResponse = () =>
  NextResponse.json(
    {
      ok: false,
      code: "PRODUCT_REVIEW_PERMISSION_FETCH_FAILED",
      message: "Nao foi possivel carregar a permissao de avaliacao.",
    },
    {
      status: 502,
      headers: NO_CACHE_HEADERS,
    }
  )

export async function GET(
  _: Request,
  context: { params: Promise<{ id: string }> }
) {
  const params = await context.params
  const validation = productParamsSchema.safeParse(params)

  if (!validation.success) {
    return NextResponse.json(
      {
        ok: false,
        code: "INVALID_PARAMS",
        message:
          validation.error.issues[0]?.message ??
          "Product id must be a positive integer.",
      },
      {
        status: 400,
        headers: NO_CACHE_HEADERS,
      }
    )
  }

  const session = await getSession()
  const sessionCookie = session?.wordpressSessionCookie?.trim()

  if (!(session && sessionCookie && session.user)) {
    return NextResponse.json(
      {
        ok: true,
        canReview: false,
        reason: "not_logged_in",
      },
      {
        headers: NO_CACHE_HEADERS,
      }
    )
  }

  try {
    const result = await getProductReviewPermission({
      productId: validation.data.id,
      sessionCookie,
      currentUser: session.user,
    })

    return NextResponse.json(result, {
      headers: NO_CACHE_HEADERS,
    })
  } catch {
    return toPermissionFetchFailedResponse()
  }
}
